import React, { useState, useEffect } from 'react';

const AdminSidebar = ({ activeTab, setActiveTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
      if (window.innerWidth >= 1024) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'users', label: 'Users', icon: '👥' },
    { id: 'products', label: 'Products', icon: '📦' },
    { id: 'incomes', label: 'Incomes', icon: '💰' },
    { id: 'purchases', label: 'Purchases', icon: '🛒' },
    { id: 'ranks', label: 'Ranks', icon: '🏆' },
    { id: 'payouts', label: 'Payouts', icon: '💸' },
    { id: 'user-payouts', label: 'User Wallets', icon: '💰' },
    { id: 'main-deposit-transfers', label: 'Main-Deposit Transfers', icon: '💸' },
    { id: 'fund-transfers', label: 'Fund Transfers', icon: '👥' },
    { id: 'payment-history', label: 'Payment History', icon: '🧾' },
    { id: 'fund-transfer', label: 'Fund Transfer', icon: '💳' },
    { id: 'investment-plans', label: 'Monthly Product Rewards', icon: '📈' },
    { id: 'lifetime-rewards', label: 'Lifetime Rewards', icon: '🏆' },
    { id: 'reports', label: 'Reports', icon: '📊' }
  ];

  const handleMenuItemClick = (itemId) => {
    setActiveTab(itemId);
    if (isMobile) {
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Mobile Toggle Button - Fixed position */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`lg:hidden fixed top-4 left-4 z-50 bg-[#E4572E] text-white p-2.5 rounded-md shadow-lg hover:bg-[#c73e1a] transition-all duration-300 ${
          isOpen ? 'left-[16.5rem]' : 'left-4'
        }`}
        aria-label="Toggle menu"
      >
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Sidebar */}
      <div
        className={`fixed lg:static top-0 left-0 h-screen w-64 sm:w-72 lg:w-64 bg-[#0F2F3D] text-white shadow-xl transform transition-transform duration-300 z-40 flex flex-col
        ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}
      >
        {/* Header - Fixed at top */}
        <div className="flex-shrink-0 p-4 sm:p-6 border-b border-white/10">
          <h2 className="text-lg sm:text-xl font-bold tracking-wide truncate">
            Admin Panel
          </h2>
          <p className="text-xs text-gray-300 mt-1 truncate">
            DESI MART
          </p>
        </div>

        {/* Scrollable Menu Area - Independent scrolling */}
        <div className="flex-1 overflow-y-auto min-h-0 scrollbar-thin scrollbar-thumb-[#E4572E]/40 hover:scrollbar-thumb-[#E4572E]">
          <nav className="p-3 sm:p-4">
            <ul className="space-y-1 sm:space-y-2">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => handleMenuItemClick(item.id)}
                    className={`relative w-full text-left px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-medium transition-all duration-300 group ${
                      activeTab === item.id
                        ? 'bg-[#E4572E] text-white shadow-md'
                        : 'text-gray-300 hover:bg-white/10 hover:text-white'
                    }`}
                  >
                    <span className="flex items-center text-sm sm:text-base">
                      {/* Menu Icon */}
                      <span className="w-6 sm:w-7 mr-2 sm:mr-3 text-base sm:text-lg flex-shrink-0">
                        {item.icon}
                      </span>
                      <span className="truncate">{item.label}</span>
                    </span>

                    {/* Active Indicator */}
                    {activeTab === item.id && (
                      <span className="absolute left-0 top-0 h-full w-1 bg-[#F47C4D] rounded-r"></span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Footer - Fixed at bottom */}
        <div className="flex-shrink-0 p-4 sm:p-6 border-t border-white/10">
          <div className="flex items-center space-x-2 text-sm text-gray-300 hover:text-white transition-colors cursor-pointer group">
            <span className="text-base sm:text-lg flex-shrink-0">⚙️</span>
            <span className="truncate text-sm">Settings</span>
          </div>
          <div className="mt-2 text-xs text-gray-400 truncate">
            Version 1.0.0
          </div>
        </div>
      </div>

      {/* Overlay for mobile */}
      {isOpen && isMobile && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm lg:hidden z-30"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
};

export default AdminSidebar;